import React, { useState } from "react";
import { LoginForm } from "./LoginForm";
import { RegisterForm } from "./RegisterForm";
import { Alert, Button, Fade, Stack } from "@mui/material";


export const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [localError, setLocalError] = useState<string | null>(null);
  
  return (
    <>
      <div className="flex justify-end">
        {localError && (
          <Fade in={!!localError} timeout={{ enter: 500, exit: 300 }}>
            <Stack
              sx={{ width: "30%", mb: 2 }}
              spacing={2}
              display="flex"
              justifyContent="flex-end"
            >
              <Alert
              
                severity="error"
                onClose={() => {
                  setTimeout(() => {
                    setLocalError(null); // Set null after the exit duration (300ms)
                  }, 300); // Match the "exit" timeout value
                }}
              >
                {localError}
              </Alert>
            </Stack>
          </Fade>
        )}
          {successMessage && (
          <Fade in={!!successMessage} timeout={{ enter: 500, exit: 300 }}>
            <Stack
              sx={{ width: "30%", mb: 2 }}
              spacing={2}
              display="flex"
              justifyContent="flex-end"
            >
              <Alert
              
                severity="success"
                onClose={() => {
                    setSuccessMessage(null); // Set null after the exit duration (300ms)
                }}
              >
                {successMessage}
              </Alert>
            </Stack>
          </Fade>
        )}
      </div>
      <div className="flex justify-center h-[90vh] relative items-center">
        <div className="max-w-md h-[85vh] rounded-md shadow-lg ">
          <img
            className="w-full rounded-t-md "
            src="https://static.vecteezy.com/system/resources/thumbnails/005/879/539/small_2x/cloud-computing-modern-flat-concept-for-web-banner-design-man-enters-password-and-login-to-access-cloud-storage-for-uploading-and-processing-files-illustration-with-isolated-people-scene-free-vector.jpg"
            alt=""
          />
          <div className="mt-8 px-10">
            {isLogin ? (
              <LoginForm
                setSuccessMessage={setSuccessMessage}
                setLocalError={setLocalError}
              />
            ) : (
              <RegisterForm
              setSuccessMessage={setSuccessMessage}
              setLocalError={setLocalError}
              />
            )}
            <div className="flex items-center gap-7 justify-center mt-5">
              <p>{isLogin && "Don't "}Have Account</p>
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  setIsLogin(!isLogin);
                }}
              >
                {isLogin ? "Create Account" : "Login"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
